import axios from 'axios';

import { API_BASE_URL, TESTENGINE_API_BASE_URL } from '../constants/config';
import * as Cookies from '../lib/Cookie';

const baseUrl = `${API_BASE_URL}`;
const testEngineBaseUrl = `${TESTENGINE_API_BASE_URL}`;
axios.defaults.withCredentials = true;
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.delete['Content-Type'] = 'application/json';
axios.defaults.headers.put['Content-Type'] = 'application/json';

const testEngineBase = (TESTENGINE_API_BASE_URL || '').trim();
axios.interceptors.request.use(config => {
  const url = config.url || '';
  if (testEngineBase && url.startsWith(testEngineBase)) {
    if (!config.headers) {
      config.headers = {};
    }
    config.headers.Authorization = `${Math.random()
      .toString(36)
      .slice(2)}${Date.now().toString(36)}`;
    config.withCredentials = true;
  }
  return config;
});

function checkResponse(res) {
  return res.response;
}

async function GET(params) {
  const { name, queryString } = params;
  const q = queryString ? `?${queryString}` : '';
  try {
    let url = baseUrl;
    axios.defaults.headers.common.Authorization = Cookies.get('quizky_token');
    let axiosConfig = {
      method: 'get',
      url: `${url}/${name}${q}`,
    };
    if (params.testengine) {
      url = testEngineBaseUrl;
      axiosConfig.url = `${url}/${name}${q}`;
      axiosConfig.withCredentials = true;
    }
    const result = await axios(axiosConfig).then(response => response.data);
    return result;
  } catch (error) {
    return checkResponse(error);
  }
}

async function POST(params) {
  const { name, queryString, payload } = params;
  const q = queryString ? `?${queryString}` : '';
  try {
    let url = baseUrl;
    axios.defaults.headers.common.Authorization = Cookies.get('quizky_token');
    let axiosConfig = {
      method: 'post',
      url: `${url}/${name}${q}`,
      data: payload,
    };
    if (params.testengine) {
      url = testEngineBaseUrl;
      axiosConfig.url = `${url}/${name}${q}`;
      axiosConfig.withCredentials = true;
    }
    const result = await axios(axiosConfig).then(response => response.data);
    return result;
  } catch (error) {
    return checkResponse(error);
  }
}

async function PUT(params) {
  const { name, queryString, payload } = params;
  const q = queryString ? `?${queryString}` : '';
  try {
    let url = baseUrl;
    axios.defaults.headers.common.Authorization = Cookies.get('quizky_token');
    let axiosConfig = {
      method: 'put',
      url: `${url}/${name}${q}`,
      data: payload,
    };
    if (params.testengine) {
      url = testEngineBaseUrl;
      axiosConfig.url = `${url}/${name}${q}`;
      axiosConfig.withCredentials = true;
    }
    const result = await axios(axiosConfig).then(response => response.data);
    return result;
  } catch (error) {
    return checkResponse(error);
  }
}

async function PATCH(params) {
  const { name, queryString, payload } = params;
  const q = queryString ? `?${queryString}` : '';
  try {
    let url = baseUrl;
    axios.defaults.headers.common.Authorization = Cookies.get('quizky_token');
    let axiosConfig = {
      method: 'patch',
      url: `${url}/${name}${q}`,
      data: payload,
    };
    if (params.testengine) {
      url = testEngineBaseUrl;
      axiosConfig.url = `${url}/${name}${q}`;
      axiosConfig.withCredentials = true;
    }
    const result = await axios(axiosConfig).then(response => response.data);
    return result;
  } catch (error) {
    return checkResponse(error);
  }
}

async function DELETE(params) {
  const { name, queryString, payload } = params;
  const q = queryString ? `?${queryString}` : '';
  try {
    let url = baseUrl;
    axios.defaults.headers.common.Authorization = Cookies.get('quizky_token');
    let axiosConfig = {
      method: 'delete',
      url: `${url}/${name}${q}`,
      data: payload,
    };
    if (params.testengine) {
      url = testEngineBaseUrl;
      axiosConfig.url = `${url}/${name}${q}`;
      axiosConfig.withCredentials = true;
    }
    const result = await axios(axiosConfig).then(response => response);
    return result;
  } catch (error) {
    return checkResponse(error);
  }
}

export default {
  GET,
  POST,
  PUT,
  PATCH,
  DELETE,
};
